import { useState } from "react";
import { useLookupBlocsQuery } from "../../stores/OkOkStore";
import type { Blocs } from "../../types/Blocs";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";
import type { QueryParameters } from "../../types/QueryParameters";

function BlocsList(){
    const [params,setParams]=useState<QueryParameters>({page:0});
    const { data, error, isLoading } = useLookupBlocsQuery(params);
    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse ?? 0});
    }


    const {translate}=useTrads();
    

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                <table className="table">
                    <thead>
                        <tr>
                            <th data-sort="clef">
                                <div className="table-sort">
                                    {translate('clef')}
                                    <div className={(params.order=='clef')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('clef',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('clef',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>
                            </th>
                            
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((bloc:Blocs) => (
                            <tr key={bloc.id}>
                                <td>{bloc.clef}</td>
                                <td>
                                    <NavLink to={`/blocs/${bloc.id.toString()}`}>
                                        <span className="visually-hidden">{translate('btn_voir')}</span>
                                        <i className="bi bi-eye-fill"></i>
                                    </NavLink>
                                </td>
                                <td>
                                    <NavLink to={`/blocs/${bloc.id.toString()}/edit`}>
                                        <span className="visually-hidden">{translate('btn_edit')}</span>
                                        <i className="bi bi-pencil-fill"></i>
                                    </NavLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default BlocsList;